import { combineReducers } from "redux";
import loginReducer from "./loginReducer";
import manageVars from "./manageVars";

export default combineReducers({
    login:loginReducer,
    vars:manageVars
})